import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuthStatus = () => {
      const user = localStorage.getItem('userName');
      const expiry = localStorage.getItem('expiry');
      
      if (user && expiry) {
        const currentTime = Date.now();
        const expiryTime = parseInt(expiry, 10);
        
        if (currentTime < expiryTime) {
          // Session is still valid
          setCurrentUser({ name: user });
        } else {
          // Session has expired
          localStorage.removeItem('userName');
          localStorage.removeItem('expiry');
          setCurrentUser(null);
        }
      } else {
        // No valid session
        setCurrentUser(null);
      }
      setLoading(false);
    };

    checkAuthStatus();

    // Set up interval to check session expiry every minute
    const interval = setInterval(() => {
      const expiry = localStorage.getItem('expiry');
      if (expiry) {
        const currentTime = Date.now();
        const expiryTime = parseInt(expiry, 10);
        
        if (currentTime >= expiryTime) {
          // Session has expired
          localStorage.removeItem('userName');
          localStorage.removeItem('expiry');
          setCurrentUser(null);
        }
      }
    }, 60000); // Check every minute

    return () => clearInterval(interval);
  }, []);

  const login = (userName) => {
    const expiryTime = Date.now() + 30 * 60 * 1000; // 30 minutes
    localStorage.setItem('userName', userName);
    localStorage.setItem('expiry', expiryTime.toString());
    setCurrentUser({ name: userName });
  };

  const logout = () => {
    localStorage.removeItem('userName');
    localStorage.removeItem('expiry');
    setCurrentUser(null);
  };

  const value = { currentUser, login, logout, loading };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
